import { render } from "./DefaultPromotionHeader.vue?vue&type=template&id=68fa4ed3&scoped=true"
import script from "./DefaultPromotionHeader.vue?vue&type=script&lang=js"
export * from "./DefaultPromotionHeader.vue?vue&type=script&lang=js"

import "./DefaultPromotionHeader.vue?vue&type=style&index=0&id=68fa4ed3&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68fa4ed3"]])

export default __exports__